<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-card  grid-list-md>
      <v-card-title class="text-h5">New Department</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5">
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              outlined autofocus
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="Department.name"
              label="Name"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close()">Close</v-btn>
        <v-btn color="green darken-1" :loading="loading" text @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DepartmentService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-Department",
  props: {
    createDialog: {
      default: false
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      Department: {
        name: null,
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Department: {
      name: {
        required
      }
    }
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Department.name.$dirty) return errors;
      if (!this.$v.Department.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    }
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Department = {
        name: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Invalid Fields", {
          timeout: 2000,
        });
      } else {
        this.loading = true;
        this.Department.name = this.Department.name.charAt(0).toUpperCase() + this.Department.name.slice(1)
        return DepartmentService.create(this.Department)
          .then(result => {
            if (result.status) {
              this.$toast.success("Department is created", {
                timeout: 2000,
              });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 2000,
            });
          });
      }
    }
  }
};
</script>

<style scoped></style>
